import { Component, inject, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'al-loader',
  imports: [CommonModule],
  template: `
    <div class="-eva-3-center">
      <div class="eva-3-loader -lg">
        <div class="loader-container">
          <div class="loader-spinner">
            <div class="spinner-container spinner-left">
              <div class="spinner-circle"></div>
            </div>
            <div class="spinner-container spinner-right">
              <div class="spinner-circle"></div>
            </div>
          </div>
        </div>
        <span class="loader-label -lg">{{ text() }}</span>
      </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class LoaderComponent {
  private readonly translateService = inject(TranslateService);
  text = input<string | undefined, string | undefined>(undefined, {
    transform: (value: string | undefined) =>
      value ?? this.translateService.instant('loader.default'),
  });
}
